export default Object.freeze({
  average: 'Average',
  down: 'Down',
  none: 'None',
  up: 'Up',
});
